import React from "react";
import "../styles/loader.css";

export const Loader = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div id="loader">
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="loading"></div>
                    </div>
                </div>
            </div>
        </>
    );
};
